import {
  QueryKey,
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '../../../constant/api';
import { api } from '../../../utils/api';

interface HyperLinkClickRequest {
  hyperlinkId: number;
  historyId: string;
  isBulk?: boolean;
}

const hyperLinkClick = ({
  hyperlinkId,
  historyId,
  isBulk = false,
}: HyperLinkClickRequest) => {
  if (isBulk) {
    return api.post<ApiResponse<undefined>>('/v2/viewer/submit/hyperlink', {
      hyperlinkId,
      historyId,
    });
  }
  return api.post<ApiResponse<undefined>>('/file/action/hyperlink', {
    hyperlinkId,
    historyId,
  });
};

const useHyperLinkClick = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    HyperLinkClickRequest,
    QueryKey
  >,
) => {
  return useMutation(hyperLinkClick, {
    ...options,
  });
};

export default useHyperLinkClick;
